// src/utils/notificationMetadata.js

const ADMIN_ROLES = new Set([
    'admin',
    'manager',
    'superadmin',
    'plataforma',
    'platformadmin',
    'admin_fracc',
]);

export const classifyRoleGroup = (rawRole) => {
    const role = typeof rawRole === 'string' ? rawRole.trim().toLowerCase() : '';
    if (!role) {
        return 'sin-clasificar';
    }
    return ADMIN_ROLES.has(role) ? 'administrador' : 'usuario';
};

export const buildNotificationActorMetadata = (userData, currentUser) => {
    const role = typeof userData?.rol === 'string' ? userData.rol.trim().toLowerCase() : '';
    const nombre = userData?.nombre || userData?.nombreCompleto || currentUser?.displayName || null;
    const email = userData?.email || currentUser?.email || null;
    const uid = userData?.uid || currentUser?.uid || null;

    return {
        actorUid: uid || null,
        actorNombre: nombre || null,
        actorEmail: email || null,
        actorRol: role || null,
        actorRolGrupo: classifyRoleGroup(role),
    };
};
